import React from "react";
import ReactSelect from "react-select";

import { StyledCompactSelectWrapper } from "./CompactSelect.styles";
import CompactSelectProps, {
    CompactSelectComponentsProps,
} from "./CompactSelect.types";
import { CompactControlComponent } from "./RCompactSelectDerived";
import {
    ClearIconComponent,
    ContainerComponent,
    DropdownIndicatorComponent,
    InputComponent,
    NoOptionsMessageComponent,
    OptionComponent,
    PlaceholderComponent,
    SingleValueComponent,
    ValueComponent,
} from "../Select/RSelectDerived";

const CompactSelect = React.forwardRef(
    (props: CompactSelectProps, ref: any) => {
        const {
            id,
            name,
            option,
            noOptionText,
            noOptionHandler,
            labelFormatter,
            value = null,
            menuPlacement = "auto",
            menuPosition = "absolute",
            components,
            ...restCommonProps
        } = props;

        const commonProps = {
            name,
            id: `${id}__container`,
            inputId: `${id}__input`,
            instanceId: id,
            ref,
            value,
            options: option,
            menuPlacement,
            menuPosition,
            components: {
                SelectContainer: ContainerComponent,
                DropdownIndicator: DropdownIndicatorComponent,
                Control: CompactControlComponent,
                SingleValue: SingleValueComponent,
                NoOptionsMessage: NoOptionsMessageComponent,
                Option: OptionComponent,
                Input: InputComponent,
                IndicatorSeparator: null,
                ValueContainer: ValueComponent,
                Placeholder: PlaceholderComponent,
                ClearIndicator: ClearIconComponent,
                ...components,
            },
            noOptionsMessage:
                noOptionHandler ?? (() => noOptionText ?? "No Option"),
            formatOptionLabel: labelFormatter,
            ...restCommonProps,
        } as CompactSelectComponentsProps;

        return (
            <StyledCompactSelectWrapper>
                <ReactSelect {...commonProps} />
            </StyledCompactSelectWrapper>
        );
    },
);

export default CompactSelect;
